module.exports = __webpack_public_path__ + "img/7-ilpakamanioMASY2.9b0c1d88.jpg";